/**
 * @generated SignedSource<<4fe13d73bad5f2a9ade7a8628aaf817b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JobTileLastRunFragment$data = {
  readonly parallelized: boolean | null;
  readonly status: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"useBuildStatusIconFragment">;
  readonly " $fragmentType": "JobTileLastRunFragment";
};
export type JobTileLastRunFragment$key = {
  readonly " $data"?: JobTileLastRunFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"JobTileLastRunFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobTileLastRunFragment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useBuildStatusIconFragment"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parallelized",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "Build",
  "abstractKey": null
};

(node as any).hash = "4eb2c0c8a904db6dba64313a5f47fa6c";

export default node;
